module.exports = __webpack_public_path__ + "static/media/importFlybook3.c43cd27d.png";